import { render, staticRenderFns } from "./MachineDettails.view.vue?vue&type=template&id=72e49c01&"
import script from "./MachineDettails.view.vue?vue&type=script&lang=js&"
export * from "./MachineDettails.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports